class ApiService {
  static baseUrl = process.env.REACT_APP_API_URL;

  static request(endpoint, method = "GET", data = null, customHeaders = {}) {
    const url = this.baseUrl + endpoint;

    const isFormData = data instanceof FormData;

    const headers = {
      Accept: "application/json",
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
      ...customHeaders,
    };

    const options = {
      method,
      headers,
      body: data ? (isFormData ? data : JSON.stringify(data)) : null,
    };

    return fetch(url, options)
      .then(async (response) => {
        const contentType = response.headers.get("content-type");

        if (!response.ok) {
          const errorData = contentType?.includes("application/json")
            ? await response.json()
            : await response.text();

          return Promise.reject(errorData);
        }

        return contentType?.includes("application/json")
          ? response.json()
          : response.text();
      })
      .catch((error) => {
        return Promise.resolve(error);
      });
  }

  static get(endpoint, customHeaders = {}) {
    return this.request(endpoint, "GET", null, customHeaders);
  }

  static post(endpoint, body, customHeaders = {}) {
    return this.request(endpoint, "POST", body, customHeaders);
  }

  static put(endpoint, body, customHeaders = {}) {
    return this.request(endpoint, "PUT", body, customHeaders);
  }

  static delete(endpoint, customHeaders = {}) {
    return this.request(endpoint, "DELETE", null, customHeaders);
  }

  static patch(endpoint, body, customHeaders = {}) {
    return this.request(endpoint, "PATCH", body, customHeaders);
  }
}

export default ApiService;
